(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["college-transfer-section"]) return;
  try {
    
  // Institucion counter.
  let institutionCounter = 1;

  // Maximum number of institucions allowed.
  const MAX_INSTITUTIONS = 5;

  // Function to update institucion indices after removal
  function updateInstitutionIndices() {
    const instRows = document.querySelectorAll('.inst-row');
    instRows.forEach((row, index) => {
      const instIndex = index + 1;
      row.setAttribute('data-inst-index', instIndex);

      // Update name field
      const nameLabel = row.querySelector('label[for^="inst"]');
      const nameInput = row.querySelector('input[id^="inst"][id$="-name"]');
      if (nameLabel && nameInput) {
        nameLabel.setAttribute('for', `inst${instIndex}-name`);
        nameLabel.textContent = `Institution ${instIndex} name`;
        nameInput.id = `inst${instIndex}-name`;
        nameInput.name = `properties[Institution${instIndex} name]`;
      }

      // Update email field
      const emailLabel = row.querySelector('label[for$="-email"]');
      const emailInput = row.querySelector('input[id$="-email"]');
      if (emailLabel && emailInput) {
        emailLabel.setAttribute('for', `inst${instIndex}-email`);
        emailLabel.textContent = `Institution ${instIndex} email`;
        emailInput.id = `inst${instIndex}-email`;
        emailInput.name = `properties[Institution${instIndex} email]`;
      }

      // Update document field.
      const docLabel = row.querySelector('label[for$="-doc"]');
      const docInput = row.querySelector('input[id$="-doc"]');
      if (docLabel && docInput) {
        docLabel.setAttribute('for', `inst${instIndex}-doc`);
        docLabel.textContent = `Institution ${instIndex} document`;
        docInput.id = `inst${instIndex}-doc`;
        docInput.name = `properties[Institution${instIndex} document]`;
      }
    });

    // Update counter.
    institutionCounter = instRows.length;

    // Show or hide the add button and message based on the number of institutions.
    const addButton = document.getElementById('add-institution');
    const maxMessage = document.getElementById('max-inst-message');
    if (institutionCounter >= MAX_INSTITUTIONS) {
      addButton.style.display = 'none';
      maxMessage.style.display = 'block';
    } else {
      addButton.style.display = 'block';
      maxMessage.style.display = 'none';
    }
  }

  // Add institution button functionality
  document.getElementById('add-institution').addEventListener('click', function() {
    // Check if maximum number of institution has been reached
    if (institutionCounter >= MAX_INSTITUTIONS) {
      return;
    }

    institutionCounter++;

    // Create a new institution row.
    const newInstRow = document.createElement('div');
    newInstRow.className = 'form-row inst-row';
    newInstRow.setAttribute('role', 'row');
    newInstRow.setAttribute('data-inst-index', institutionCounter);

    // Institution name field.
    const nameField = document.createElement('div');
    nameField.className = 'form-field';
    nameField.setAttribute('role', 'cell');

    const nameLabel = document.createElement('label');
    nameLabel.setAttribute('for', `inst${institutionCounter}-name`);
    nameLabel.textContent = `Institution ${institutionCounter} name`;

    const nameInput = document.createElement('input');
    nameInput.id = `inst${institutionCounter}-name`;
    nameInput.type = 'text';
    nameInput.className = 'product-form__input width-100';
    nameInput.name = `properties[Institution${institutionCounter} name]`;

    nameField.appendChild(nameLabel);
    nameField.appendChild(nameInput);

    // Institution email field.
    const emailField = document.createElement('div');
    emailField.className = 'form-field';
    emailField.setAttribute('role', 'cell');

    const emailLabel = document.createElement('label');
    emailLabel.setAttribute('for', `inst${institutionCounter}-email`);
    emailLabel.textContent = `Institution ${institutionCounter} email`;

    const emailInput = document.createElement('input');
    emailInput.id = `inst${institutionCounter}-email`;
    emailInput.type = 'email';
    emailInput.className = 'product-form__input width-100';
    emailInput.name = `properties[Institution${institutionCounter} email]`;

    emailField.appendChild(emailLabel);
    emailField.appendChild(emailInput);

    // Institution document field.
    const docField = document.createElement('div');
    docField.className = 'form-field';
    docField.setAttribute('role', 'cell');

    const docLabel = document.createElement('label');
    docLabel.setAttribute('for', `inst${institutionCounter}-doc`);
    docLabel.textContent = `Institution ${institutionCounter} document`;

    const docInput = document.createElement('input');
    docInput.id = `inst${institutionCounter}-doc`;
    docInput.type = 'file';
    docInput.className = 'product-form__input width-100';
    docInput.name = `properties[Institution${institutionCounter} document]`;
    docInput.accept = '.docx, .pdf, .doc';

    docField.appendChild(docLabel);
    docField.appendChild(docInput);

    // Add all fields to the row
    newInstRow.appendChild(nameField);
    newInstRow.appendChild(emailField);
    newInstRow.appendChild(docField);

    // Add actions div with the remove button.
    const actionsDiv = document.createElement('div');
    actionsDiv.className = 'inst-actions form-field remove-cell';

    const removeButton = document.createElement('button');
    removeButton.type = 'button';
    removeButton.className = 'remove-inst';
    removeButton.textContent = 'Remove';
    removeButton.addEventListener('click', function() {
      newInstRow.remove();
      updateInstitutionIndices();
    });

    actionsDiv.appendChild(removeButton);
    newInstRow.appendChild(actionsDiv);

    // Add the new row to the container
    document.getElementById('institution-container').appendChild(newInstRow);

    // Check if maximum institution reached and update UI
    updateInstitutionIndices();
  });

  // Initialize button and message visibility when the page loads
  updateInstitutionIndices();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["courier-section"]) return;
  try {
    

  function clearForm() {
	$("input:text[id^='form-field-']").each(function() {
	  $(this).val("");
    });

	$("input:radio[id^='form-field-']").prop('checked', false);	
  }

  function toogleRequired(value, current) {
	var styleClassName = value.toLowerCase();
	if (value !== current) {
		$("tr." + styleClassName + " input[id^='form-field-']").prop('required', false);
		$("tr." + styleClassName + " input[id^='form-field-']").removeClass('required');
	} else {
		$("tr." + styleClassName + " input[id^='form-field-']").prop('required', true);
		$("tr." + styleClassName + " input[id^='form-field-']").addClass('required');
	}
  }

  function requiredFields(parchmentType) {
	var sections = ['Degree', 'Diploma', 'Certificate'];
	//sections.forEach(item => toogleRequired(item, parchmentType));
	sections.forEach(function(element) {
	  toogleRequired(element, parchmentType);
	});
  }

  $("input[name='properties[Document type]']").on("change", function() {
    var parchmentType = $(this).val();

	if (parchmentType === 'Degree') {
	  $("tr.degree").removeClass("visually-hidden");
	  $("tr.diploma").addClass("visually-hidden");
  	  $("tr.certificate").addClass("visually-hidden");
	} else if (parchmentType === 'Diploma') {
  	  $("tr.degree").addClass("visually-hidden");
  	  $("tr.diploma").removeClass("visually-hidden");
  	  $("tr.certificate").addClass("visually-hidden");
	} else if (parchmentType === 'Certificate') {
  	  $("tr.degree").addClass("visually-hidden");
  	  $("tr.diploma").addClass("visually-hidden");
  	  $("tr.certificate").removeClass("visually-hidden");

	} else {
  	  $("tr.degree").addClass("visually-hidden");
  	  $("tr.diploma").addClass("visually-hidden");
  	  $("tr.certificate").addClass("visually-hidden");
	}

	clearForm();
	requiredFields(parchmentType);

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duplicate-diploma-section"]) return;
  try {
    

  function clearForm() {
	$("input:text[id^='form-field-']").each(function() {
	  $(this).val("");
    });

	$("input:radio[id^='form-field-']").prop('checked', false);	
  }

  function toogleRequired(value, current) {
	var styleClassName = value.toLowerCase();
	if (value !== current) {
		$("tr." + styleClassName + " input[id^='form-field-']").prop('required', false);
		$("tr." + styleClassName + " input[id^='form-field-']").removeClass('required');
	} else {
		$("tr." + styleClassName + " input[id^='form-field-']").prop('required', true);
		$("tr." + styleClassName + " input[id^='form-field-']").addClass('required');
	}
  }

  function requiredFields(parchmentType) {
	var sections = ['Degree', 'Diploma', 'Certificate'];
	//sections.forEach(item => toogleRequired(item, parchmentType));
	sections.forEach(function(element) {
	  toogleRequired(element, parchmentType);
	});
  }

  $("input[name='properties[Document type]']").on("change", function() {
    var parchmentType = $(this).val();

	if (parchmentType === 'Degree') {
	  $("tr.degree").removeClass("visually-hidden");
	  $("tr.diploma").addClass("visually-hidden");
  	  $("tr.certificate").addClass("visually-hidden");
	} else if (parchmentType === 'Diploma') {
  	  $("tr.degree").addClass("visually-hidden");
  	  $("tr.diploma").removeClass("visually-hidden");
  	  $("tr.certificate").addClass("visually-hidden");
	} else if (parchmentType === 'Certificate') {
  	  $("tr.degree").addClass("visually-hidden");
  	  $("tr.diploma").addClass("visually-hidden");
  	  $("tr.certificate").removeClass("visually-hidden");

	} else {
  	  $("tr.degree").addClass("visually-hidden");
  	  $("tr.diploma").addClass("visually-hidden");
  	  $("tr.certificate").addClass("visually-hidden");
	}

	clearForm();
	requiredFields(parchmentType);

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enrolment"]) return;
  try {
    
  //clear custom form
  function clearCustomForm() {
    $("input:text[id^='form-custom']").each(function() {
      $(this).val("");
    });

    $("#form-custom-doc").val('').clone(true);
  }

  //clear regular form
  function clearRegularForm() {
    $("input:text[id^='form-reg']").each(function() {
      $(this).val("");
    });

    $("input:checkbox[id^='form-reg']:checked").each(function() {
      $(this).prop('checked', false);
    });
  }

  //hide all dependent sections
  $(".form-custom").addClass("visually-hidden");
  $(".form-regular").addClass("visually-hidden");

  /* Adding control over whats displayed */
  $("input[name='properties[Form type]']").on("change", function() {
    var formType = $(this).val();

    if (formType === 'Undergraduate' || formType === 'Graduate') {
      $(".form-custom").addClass("visually-hidden");
      $(".form-regular").removeClass("visually-hidden");

      clearCustomForm();
      clearRegularForm();

      if (formType === 'Undergraduate') {
        $(".grad-only").addClass("visually-hidden");
        $(".ug-only").removeClass("visually-hidden");
      }
      else {
        $(".grad-only").removeClass("visually-hidden");
        $(".ug-only").addClass("visually-hidden");
      }
    }
    else {
      $(".form-custom").removeClass("visually-hidden");
      $(".form-regular").addClass("visually-hidden");

      clearRegularForm();
    }

    fillHidden('Form-sections')

  });


  //$("#letter_purpose_other_field").addClass("visually-hidden");
  $("#letter_purpose_other_field").prop( "disabled", true );

  $("#letter_purpose_other_field").prop("required", false);

  $("input[name='properties[Letter purpose]']").on("change", function() {
	var purposeType = $(this).val();

	if (purposeType === "Other") {
	  //$("#letter_purpose_other_field").removeClass("visually-hidden");
	  $("#letter_purpose_other_field").prop( "disabled", false );
	  $("#letter_purpose_other_field").prop("required", true);
	  $("#letter_purpose_other_field").focus();

	}
	else {
	  //$("#letter_purpose_other_field").addClass("visually-hidden");
	  $("#letter_purpose_other_field").prop( "disabled", true );
	  $("#letter_purpose_other_field").prop("required", false);
	  $("#letter_purpose_other_field").val("");
	}
  });

  $("input[name='properties[Student Career]']").on("change", function(){
    var career = $(this).val();

    if (career === 'Graduate') {
	  $("#form_type_ug").prop("checked", false);
	  $("#form_type_ug").prop("disabled", true);
	  $("#form_type_gr").prop("disabled", false);
    }
	else {
	  $("#form_type_gr").prop("checked", false);
	  $("#form_type_gr").prop("disabled", true);
	  $("#form_type_ug").prop("disabled", false);
	}

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enrolment_2019"]) return;
  try {
    
  	$("#letter_purpose_other_field").prop("disabled", true );
  	$("#letter_purpose_other_field").prop("required", false);

  	$("input[name='properties[Letter purpose]']").on("change", function() {
		var purposeType = $(this).val();

		if (purposeType === "Other") {
	  		$("#letter_purpose_other_field").prop( "disabled", false );
	  		$("#letter_purpose_other_field").prop("required", true);
	  		$("#letter_purpose_other_field").focus();

		}
		else {
	  		$("#letter_purpose_other_field").prop( "disabled", true );
	  		$("#letter_purpose_other_field").prop("required", false);
	  		$("#letter_purpose_other_field").val("");
		}
	});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["letter-of-permission"]) return;
  try {
    
  console.log('checkpoint1');

  $("select[id='faculty']").prop("selectedIndex", -1);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proof-enrolment"]) return;
  try {
    
  console.log("checkpoint 1");

  //clear custom form
  function clearCustomForm() {
    $("input:text[id^='form-custom']").each(function() {
      $(this).val("");
    });

    $("#form-custom-doc").val('').clone(true);
  }

  //clear regular form
  function clearRegularForm() {
    $("input:text[id^='form-reg']").each(function() {
      $(this).val("");
    });

    $("input:checkbox[id^='form-reg']:checked").each(function() {
      $(this).prop('checked', false);
    });
  }

  //hide all dependent sections
  $(".form-custom").addClass("visually-hidden");
  $(".form-regular").addClass("visually-hidden");

  /* Adding control over whats displayed */
  $("input[name='properties[Form type]']").on("change", function() {
    var formType = $(this).val();

	console.log("hello from otherside");

    if (formType === 'Undergraduate' || formType === 'Graduate') {
      $(".form-custom").addClass("visually-hidden");
      $(".form-regular").removeClass("visually-hidden");

      clearCustomForm();
      clearRegularForm();

      if (formType === 'Undergraduate') {
        $(".grad-only").addClass("visually-hidden");
        $(".ug-only").removeClass("visually-hidden");
      }
      else {
        $(".grad-only").removeClass("visually-hidden");
        $(".ug-only").addClass("visually-hidden");
      }
    }
    else {
      $(".form-custom").removeClass("visually-hidden");
      $(".form-regular").addClass("visually-hidden");

      clearRegularForm();
    }

    fillHidden('Form-sections')

  });

  $("#letter_purpose_other_field").addClass("visually-hidden");

  $("input[name='properties[Letter purpose]']").on("change", function() {
	var purposeType = $(this).val();

	if (purposeType === 'Other') {
	  $("#letter_purpose_other_field").removeClass("visually-hidden");
	}
	else {
	  $("#letter_purpose_other_field").addClass("visually-hidden");
	}
  });


  $("input[name='properties[Student Career]']").on("change", function(){
    var career = $(this).val();
    console.log("Changed option to " + career);

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["replacement-diploma-section"]) return;
  try {
    

  function clearForm() {
	$("input:text[id^='form-field-']").each(function() {
	  $(this).val("");
    });

	$("input:radio[id^='form-field-']").prop('checked', false);	
  }


  function toogleRequired(value, current) {
	if (value !== current) {
		$("tr." + value + " input[id^='form-field-']").prop('required', false);
		$("tr." + value + " input[id^='form-field-']").removeClass('required');
	} 
    else {
		$("tr." + value + " input[id^='form-field-']").prop('required', true);
		$("tr." + value + " input[id^='form-field-']").addClass('required');
	}
  }

  function requiredFields(parchmentType) {
	var sections = ['degree', 'diploma', 'certificate'];
	
	sections.forEach(function(element) {
	  toogleRequired(element, parchmentType);
	});
  }

  // field = tr.statutory-declaration
  function showFields(field, show) {
	if (show) {
	  $(field).removeClass('visually-hidden');
	  $(field + " input[id^='form-field-']").prop('required', true);
	  $(field + " input[id^='form-field-']").addClass('required');

	  $(field + " select[id^='form-field-']").prop('required', true);
	  $(field + " select[id^='form-field-']").addClass('required');
	} 
    else {
	  $(field).addClass('visually-hidden');
	  $(field + " input[id^='form-field-']").prop('required', false);
	  $(field + " input[id^='form-field-']").removeClass('required');

	  $(field + " select[id^='form-field-']").prop('required', false);
	  $(field + " select[id^='form-field-']").removeClass('required');
	}
  }

  // Type requested logic.
  $("input[name='properties[Document type]']").on("change", function() {
    var parchmentType = $(this).val();

	if (parchmentType === 'degree') {
	  $("tr.degree").removeClass('visually-hidden');
	  $("tr.diploma").addClass('visually-hidden');
  	  $("tr.certificate").addClass('visually-hidden');
	} 
    else if (parchmentType === 'diploma') {
  	  $("tr.degree").addClass('visually-hidden');
  	  $("tr.diploma").removeClass('visually-hidden');
  	  $("tr.certificate").addClass('visually-hidden');
	} 
    else if (parchmentType === 'certificate') {
  	  $("tr.degree").addClass('visually-hidden');
  	  $("tr.diploma").addClass('visually-hidden');
  	  $("tr.certificate").removeClass('visually-hidden');

	} 
    else {
  	  $("tr.degree").addClass('visually-hidden');
  	  $("tr.diploma").addClass('visually-hidden');
  	  $("tr.certificate").addClass('visually-hidden');
	}

	clearForm();
	requiredFields(parchmentType);

  });

  // Replace reason logic.
  $("input[name='properties[Replace reason]']").on("change", function() {
	var replacementReason = $(this).val();

	$("select[id^='form-field-']").prop("selectedIndex", -1);

	if (replacementReason === 'Lost') {
	  showFields("tr.statutory-declaration", true);
	  showFields("tr.proof-of-destruction", false);
	  showFields("tr.sending-damaged-diploma", false);
	  showFields("tr.sending-old-diploma", false);
	} 
    else if (replacementReason === 'Damaged') {	
	  showFields("tr.proof-of-destruction", false);
	  showFields("tr.sending-damaged-diploma", true);

	  currentState = $("#form-field-original-diploma").val();

	  if (currentState === 'attached') {
		showFields("tr.statutory-declaration", true);	  
	  } 
      else {
		showFields("tr.statutory-declaration", false);
	  }
	  showFields("tr.sending-old-diploma", false);
	} 
    else if (replacementReason === 'Name changed') {
	  showFields("tr.statutory-declaration", false);
	  showFields("tr.sending-damaged-diploma", false);
	  showFields("tr.sending-old-diploma", true);
	}
  });

  $("#form-field-damaged-diploma").on("change", function() { 
	var originalDiplomaAction = $(this).val();

	if (originalDiplomaAction === 'attached') {
	  showFields("tr.statutory-declaration", true);
      showFields("tr.proof-of-destruction", false);
	} 
    else if (originalDiplomaAction === 'proof of destruction') {
      showFields("tr.proof-of-destruction", true);
      showFields("tr.statutory-declaration", false);
    }
    else {
	  showFields("tr.statutory-declaration", false);
      showFields("tr.proof-of-destruction", false);
	}
  });

  // Reacting on Original diploma drop down selection.
  $("#form-field-original-diploma").on("change", function() { 
    var originalDiplomaAction = $(this).val();
    if (originalDiplomaAction === 'proof of destruction') {
        showFields("tr.proof-of-destruction", true);
      }
    else {
        showFields("tr.proof-of-destruction", false);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transcript"]) return;
  try {
    
  //clear custom form
  function clearCustomForm() {
    $("input:text[id^='form-custom']").each(function() {
      $(this).val("");
    });

    $("#form-custom-doc").val('').clone(true);
  }

  $(".form-custom").addClass("visually-hidden");
  
  $("input[name='properties[Form type]']").on("change", function() {
    var formType = $(this).val();

	if (formType === "Custom") {
 	  $(".form-custom").removeClass("visually-hidden");		
	}
	else {
	  $(".form-custom").addClass("visually-hidden");
	  clearCustomForm();
  	}

  });


  } catch(e) { console.error(e); }
})();
})();
